import React from 'react';
import { Link, Notice } from '@applyboard/crystal-ui';
import { Box } from '@applyboard/ui-components';
import { usePageSettings } from "../PageSettings";
import { useEventTracker } from '@applyboard/ui-utils';
export var PendingPaymentNotification = function PendingPaymentNotification(props) {
  var _props$application, _props$application2, _props$application2$m, _props$application3, _props$application3$s;
  // Temporary solution until the student profile page is added to the school SPA
  // https://applyboard.atlassian.net/browse/SCH-72
  var _usePageSettings = usePageSettings(),
    appName = _usePageSettings.appName;
  var isSchoolApp = appName === 'school';
  var _useEventTracker = useEventTracker(),
    trackEvent = _useEventTracker.trackEvent;
  if ((_props$application = props.application) !== null && _props$application !== void 0 && _props$application.paid) {
    return null;
  }
  return /*#__PURE__*/React.createElement(Box, {
    mb: 2,
    pr: 2
  }, /*#__PURE__*/React.createElement(Notice, {
    intent: "warning"
  }, (_props$application2 = props.application) !== null && _props$application2 !== void 0 && (_props$application2$m = _props$application2.meta) !== null && _props$application2$m !== void 0 && _props$application2$m.outstanding_pre_payment_requirements ? 'Application will not be processed until payment received. Complete all pre-payment requirements to be able to pay.' : /*#__PURE__*/React.createElement(React.Fragment, null, "Application will not be processed until payment received.", ' ', !isSchoolApp && /*#__PURE__*/React.createElement(Link, {
    href: "".concat((_props$application3 = props.application) === null || _props$application3 === void 0 ? void 0 : (_props$application3$s = _props$application3.student) === null || _props$application3$s === void 0 ? void 0 : _props$application3$s.student_link, "/applications"),
    onClick: function onClick() {
      trackEvent({
        event: 'Single Application - Prepayment Banner - Clicked Submit Payment Now'
      });
    }
  }, "Submit payment now"))));
};